import { render, staticRenderFns } from "./FaceGuide.vue?vue&type=template&id=17925bd0&scoped=true&"
import script from "./FaceGuide.vue?vue&type=script&lang=js&"
export * from "./FaceGuide.vue?vue&type=script&lang=js&"
import style0 from "./FaceGuide.vue?vue&type=style&index=0&id=17925bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17925bd0",
  null
  
)

export default component.exports